<div class="container section lobby">
    <a (click)="goback()"> <i class="fa fa-arrow-left" aria-hidden="true"></i>Go Back</a>
    <h1>Chapter Lobbying Percentage</h1>

    <form class="full-width" >
        <table class="table table-striped">
            <thead>
              <tr>               
                <th scope="col">Chapter Name</th>
                <th scope="col">Lobbying Percentage</th>               
              </tr>
            </thead>
            <tbody>

              <tr *ngFor="let obj of lobbyData" >              
                <td>{{obj.name}}</td>
                <td>{{obj.lobbyPercentage}}</td>      
              </tr>
            </tbody>
        </table>
    </form>
</div>